import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=6a241e95&"
import script from "./Ver.vue?vue&type=script&lang=ts&"
export * from "./Ver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports